import { api } from "./client";

export interface Contact {
  id: string;
  company_id: string;
  role_name: string | null;
  name: string;
  email: string | null;
  portal_enabled: number;  // 0 or 1
  created_at: string;
}

export const contactsApi = {
  list: () => api.get<Contact[]>("/api/contacts"),

  create: (body: {
    roleName?: string;
    name: string;
    email?: string;
    passwordHash?: string;
    portalEnabled?: boolean;
  }) => api.post<{ id: string }>("/api/contacts", body),

  update: (id: string, body: Partial<{
    roleName: string;
    name: string;
    email: string;
    passwordHash: string;
    portalEnabled: boolean;
  }>) => api.patch<{ ok: boolean }>(`/api/contacts/${id}`, body),

  remove: (id: string) => api.delete<{ ok: boolean }>(`/api/contacts/${id}`),
};
